<template>
  <div>
    <el-button
      icon="el-icon-plus"
      v-if="!($store.state.userPower==='C')"
      round
      type="primary"
      @click="dialogVisible = true"
    >Add New Materials</el-button>

    <MaterialAddForm :dialogVisible.sync="dialogVisible" @refresh-list="refreshList" />
    <MaterialCollapseList :material-list="materialList" @refresh-list="refreshList" />
  </div>
</template>

<script>
import MaterialAddForm from "@/components/MaterialAddForm.vue";
import MaterialCollapseList from "@/components/MaterialCollapseList.vue";
import { getMaterialListByClass } from "@/api/materials.js";

export default {
  name: "Download",
  components: {
    MaterialAddForm,
    MaterialCollapseList
  },
  data() {
    return {
      materialList: [],
      dialogVisible: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    refreshList() {
      this.getData();
    },
    async getData() {
      const res = await getMaterialListByClass(this.$route.params.class_id);
      this.materialList = res.map((item,index) => ({
        index,
        ...item
      }))
    }
  }
};
</script>

<style>
</style>